import React from 'react'
import {
  AuthenticatedTemplate,
  MsalAuthenticationTemplate,
} from '@azure/msal-react'
import { InteractionType } from '@azure/msal-browser'
import './Protected.css'
import { ErrorBoundary } from 'react-error-boundary'
import ErrorFallback from './common/ErrorFallback'

const LoadingComponent = () => {
  return (
    <div className="redirect-overlay">
      <div className="justify-content-center">
        <p>
          <b>Please wait while you are redirected</b>
        </p>
        <div className="pacterpillar">
          <div></div>
          <div></div>
          <div></div>
          <div></div>
        </div>
      </div>
    </div>
  )
}

const ErrorComponent = ({ error }) => {
  return (
    <div className="redirect-overlay">
      <div className="justify-content-center overlay">
        <div>
          <p>An Error Occurred: {error.errorMessage}</p>
        </div>
      </div>
    </div>
  )
}

const Protected = (props) => {
  const authRequest = {
    scopes: ['profile', 'email', 'openid', 'offline_access'],
  }

  return (
    <>
      <MsalAuthenticationTemplate
        interactionType={InteractionType.Redirect}
        authenticationRequest={authRequest}
        errorComponent={ErrorComponent}
        loadingComponent={LoadingComponent}
      ></MsalAuthenticationTemplate>
      <AuthenticatedTemplate>
        <ErrorBoundary FallbackComponent={ErrorFallback}>
          {props.children}
        </ErrorBoundary>
      </AuthenticatedTemplate>
    </>
  )
}

export default Protected
